/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export interface ToggleReportIconProps extends SvgIconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  style?: React.CSSProperties;
}

export default function SortIcon({
  width = 24,
  height = 24,
  style,
  fill = 'currentColor',
  ...props
}: ToggleReportIconProps) {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width, height, ...style }}
      {...props}
    >
      <path d="M11.3333 15.7333V8.26667C11.3333 7.95556 11.2 7.74444 10.9333 7.63333C10.6667 7.52222 10.4222 7.57778 10.2 7.8L6.93333 11.0667C6.66667 11.3333 6.53333 11.6444 6.53333 12C6.53333 12.3556 6.66667 12.6667 6.93333 12.9333L10.2 16.2C10.4222 16.4222 10.6667 16.4778 10.9333 16.3667C11.2 16.2556 11.3333 16.0444 11.3333 15.7333ZM2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H21.3333C22.0667 0 22.6944 0.261111 23.2167 0.783333C23.7389 1.30556 24 1.93333 24 2.66667V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM14.6667 21.3333V2.66667H2.66667V21.3333H14.6667Z" fill={fill}/>

    </SvgIcon>
  );
}
